import NamedDto from 'modules/base/dto/NamedDto';

export default class DriverLogTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.tableName = null;
	}

	/**
	 * @typedef {Object} _DriverLogTableDtoProps
	 * @property {string} tableName
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _DriverLogTableDtoProps} DriverLogTableDtoProps
	 */
	/**
	 *
	 * @param {DriverLogTableDtoProps} props
	 * @returns {DriverLogTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.tableName = props.tableName;
		return this;
	}
}
